module.exports = __webpack_public_path__ + "static/media/icon_newsletter--failure.443d0843.svg";